"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurningDesireAbilityHandler = exports.BurningDesireActorAbilityFactory = exports.BurningDesireAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const CameraAction_1 = require("../../core/vfx/CameraAction");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class BurningDesireAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BurningDesire;
        this.__typeName = "BurningDesire";
    }
}
exports.BurningDesireAbilityArgs = BurningDesireAbilityArgs;
let BurningDesireActorAbilityFactory = class BurningDesireActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BurningDesire", "Self", 4);
    }
};
BurningDesireActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BurningDesire")
], BurningDesireActorAbilityFactory);
exports.BurningDesireActorAbilityFactory = BurningDesireActorAbilityFactory;
let BurningDesireAbilityHandler = class BurningDesireAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ability.invokerId, "feet"), "FireMagicCircle"))
                    .push(core_1.CameraVfxStepArgs.Effect(new CameraAction_1.EffectVfxCameraAction("shake"), 600));
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.AllDamagePercentIncrease, 40),
                });
            }
        });
    }
};
BurningDesireAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BurningDesire)
], BurningDesireAbilityHandler);
exports.BurningDesireAbilityHandler = BurningDesireAbilityHandler;
